/** @file Description - Renders non-critical help text. */
import p from 'vue-strict-prop';
import * as tsx from 'vue-tsx-support';
import * as constants from '../constants';
import { injectFieldContext, useFieldContextValue } from '../context';
/** The description of a control component in the form element. */
export const Description = tsx.component({
    name: constants.nameDescription,
    inject: injectFieldContext(),
    computed: useFieldContextValue(),
    props: {
        descriptionStyle: p.ofType().default('body-small'),
    },
    /** @returns The local state of the component. */
    data() {
        return {
            id: undefined,
        };
    },
    /** Register with the parent Field upon creation. */
    created() {
        this.id = this.fieldContext.register('description');
    },
    /** Deregister with the parent Field before destroy. */
    beforeDestroy() {
        if (this.id != null) {
            this.fieldContext.deregister(this.id);
        }
    },
    /** @returns Results of render function. */
    render() {
        return (<div id={this.id} class={[constants.nameDescription, this.descriptionStyle]}>
                {this.$slots.default}
            </div>);
    },
});
